<script setup>
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState'

const {
  selected,
  relatedStockCurrent,
  resolveImageUrl,
  mapRelated,
  selectArticle,
} = useCatalogState();
</script>

<template>
  <div class="w-full dark:text-white" style="min-height: 250px; max-height: 1000px;">
    <h3 class="font-bold">Sorodni artikli</h3>
    <div class="relative grid grid-cols-1 gap-4 w-full mt-2 mb-2">
      <a href="#" v-for="(row, i) in mapRelated(selected.related)" @click.prevent="selectArticle(row)" class="py-4 flex bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">

        <!-- Article image -->
        <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-if="row.thumbnailUrl">
          <img :src="row.thumbnailUrl" alt="" style="max-width: 50px; max-height: 50px;" />
        </div>
        <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && nearestParentCategoryLargeImageUrl">
          <img :src="nearestParentCategoryLargeImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
        </div> -->
        <div class="grid place-items-center text-gray-200 dark:text-gray-700 text-center w-24 mx-4" style="font-size: 48px; width: 50px; height: 50px;" v-else>
          <i class="fa fa-image"></i>
        </div>

        <!-- Article name and SKU -->
        <div class="w-full pr-3 grid items-center">
          <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.name">{{ row.name }}</h5>
          <h3 class="mt-0 text-slate-400" v-if="row.sku">{{ row.sku }}</h3>
        </div>

      </a>
    </div>
  </div>
</template>